import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  slimLayout: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
  },
  slimContent: {
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    overflow: 'hidden',
  },
}));

export default useStyles;
